import { render, staticRenderFns } from "./createWithWaybillNo.vue?vue&type=template&id=674363aa&scoped=true&"
import script from "./createWithWaybillNo.vue?vue&type=script&lang=js&"
export * from "./createWithWaybillNo.vue?vue&type=script&lang=js&"
import style0 from "./createWithWaybillNo.vue?vue&type=style&index=0&id=674363aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674363aa",
  null
  
)

export default component.exports